module.exports = __webpack_public_path__ + "static/media/trees.806ce5e8.JPG";